import { useState } from "react";

function useMediaManager() {
  const [mediaManager, setMediaManager] = useState({
    open: false,
    onSelect: (media) => {
      console.log(media);
    },
  });
  return [mediaManager, setMediaManager];
}

export default useMediaManager;
